import React, { useEffect, useState } from "react";
import * as apiClient from "../../../common/apiClient";
import { Link } from "react-router-dom";

const OrderRenewHistoryTab = ({ orderId }) => {

    const [data, setData] = useState([]);

    useEffect(() => {

        if (orderId) {
            loadData();
        }

    }, [orderId]);

    const loadData = () => {

        apiClient.getOrderRenewHistory(orderId)
            .then(res => {

                setData(res || []);

            })
            .catch(err => {
                console.log(err);
            });

    };

    const columns =
        data.length > 0
            ? Object.keys(data[0])
                .filter(col => col.toUpperCase() !== "ID")
                .map(col => ({
                    field: col,
                    label: col
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase()),
                    isLink:
                        col.toUpperCase() === "ORDERNO"
                }))
            : [];

    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        minWidth: "2200px",
        fontSize: "12px"
    };

    const thStyle = {
        border: "1px solid #dcdcdc",
        padding: "8px",
        background: "#f5f5f5",
        fontWeight: "600",
        textAlign: "left",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 1
    };

    const tdStyle = {
        border: "1px solid #e0e0e0",
        padding: "7px",
        whiteSpace: "nowrap"
    };

    return (

        <div
            style={{
                width: "100%",
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "450px",
                border: "1px solid #dcdcdc",
                borderRadius: "5px",
                background: "#fff"
            }}
        >

            <table style={tableStyle}>

                <thead>

                    <tr>

                        {
                            columns.map((col, index) => (

                                <th
                                    key={index}
                                    style={{
                                        ...thStyle,
                                        textAlign: col.align || "left"
                                    }}
                                >
                                    {col.label}
                                </th>

                            ))
                        }

                    </tr>

                </thead>

                <tbody>

                    {
                        data.map((item, rowIndex) => {

                            const netPremium =
                                Number(item.odPremAmt || 0)
                                +
                                Number(item.tpPremiumAmt || 0);

                            return (

                                <tr
                                    key={rowIndex}
                                    style={{
                                        background:
                                            rowIndex % 2 === 0
                                                ? "#ffffff"
                                                : "#fafafa"
                                    }}
                                >

                                    {
                                        columns.map((col, colIndex) => {

                                            let value = "";

                                            if (col.field === "NetPremium") {
                                                value = netPremium;
                                            }
                                            else {
                                                value = item[col.field];
                                            }

                                            return (

                                                <td
                                                    key={colIndex}
                                                    style={{
                                                        ...tdStyle,
                                                        textAlign: col.align || "left"
                                                    }}
                                                >

                                                    {
                                                        col.isLink
                                                            ?
                                                            (
                                                                <Link
                                                                    to={`/orders/${item.id}`}
                                                                    style={{
                                                                        color: "#1976d2",
                                                                        textDecoration: "none",
                                                                        fontWeight: "600"
                                                                    }}
                                                                >
                                                                    {value}
                                                                </Link>
                                                            )
                                                            :
                                                            value
                                                    }

                                                </td>

                                            );

                                        })
                                    }

                                </tr>

                            );

                        })
                    }

                </tbody>

            </table>

        </div>

    );

};

export default OrderRenewHistoryTab;